import { render } from "./Booking.vue?vue&type=template&id=1ebec1f2"
import script from "./Booking.vue?vue&type=script&lang=js"
export * from "./Booking.vue?vue&type=script&lang=js"

import "./Booking.vue?vue&type=style&index=0&id=1ebec1f2&lang=scss"

import exportComponent from "/Users/sarah.veysset/S/TRAVAIL/FREELANCE/OSTEO BARRY/osteo-barry/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__